import type { QueuedCapture } from './offline';

/**
 * What is actually holding this capture up.
 *
 * Every row that had not uploaded read "waiting for connection", whatever the
 * reason, so a capture the server was refusing looked identical to one taken
 * in a basement. `lastError` already held the server's answer and nothing
 * displayed it, which is what hid a run of 400s behind a plausible story
 * about signal.
 */
export function stateLine(item: QueuedCapture, online: boolean): string {
  switch (item.status) {
    case 'uploaded':
      return 'Uploaded. Extraction is running.';
    case 'uploading':
      return 'Uploading now.';
    case 'failed':
      if (item.refusal === 'payment_required') return 'Not sent. The account cannot start captures.';
      if (item.refusal === 'duplicate_in_job') return 'Not sent. Already in this job.';
      return `Stopped after ${item.attempts} attempts.`;
    default:
      if (item.attempts > 0) {
        return `Retrying. ${item.attempts} ${item.attempts === 1 ? 'attempt' : 'attempts'} so far.`;
      }
      return online ? 'Waiting for the next upload pass.' : 'Waiting for a connection.';
  }
}
